import React from 'react';
import TextField from '@mui/material/TextField';
import Style from './Contact.module.scss';


const Contact = () => {
  return (
    <div className="container">
      <h1>Contact Us</h1>
      <p>Excited to host an amazing virtual event with HiFair? So are we! Get started right away</p>

      <form className={Style.form_container}>

        <div style={{display:'flex'}}>
          <TextField className={Style.textbox} label="First name*" variant="outlined" fullWidth/>
          <TextField className={Style.textbox} label="Last name*" variant="outlined" fullWidth/>
        </div>
        <div style={{display:'flex'}}>
          <TextField className={Style.textbox} label="Email*" variant="outlined" fullWidth/>
          <TextField className={Style.textbox} label="Company name*" variant="outlined" fullWidth/>
        </div>
        <div style={{display:'flex'}}>
          <TextField className={Style.textbox} label="Phone number*" variant="outlined" fullWidth/>
          <TextField className={Style.textbox} label=" Budget*" variant="outlined" fullWidth/>
        </div>
        <div style={{display:'flex'}}>
          <TextField className={Style.textbox} label=" What kind of event are you planning*" variant="outlined" multiline maxRows={4} fullWidth/>
        </div>












      </form>

      Salessales@vfairs.com
      Marketingmarketing@vfairs.com
      Supportsupport@vfairs.com
      RFPsrfp@vfairs.com
      Partnerspartners@vfairs.com


    </div>
  )
}

export default Contact;